import { css } from "@emotion/react";
import { Spacing, Colors, FontWeight } from "@snapchat/snap-design-system";
import { Heading } from "@snapchat/snap-design-system/lib/constants/fonts";

export const _containerStyle = css`
    background-color: ${Colors.Gray.V100};
    padding: ${Spacing.MD}px;
    border-left: 5px solid ${Colors.Yellow.V200};
`;

export const titleContainerStyle = css`
    ${Heading.H500};
    margin-bottom: ${Spacing.XS}px;
`;
export const titleStyle = css`
    margin-left: ${Spacing["1XS"]}px;
    text-transform: uppercase;
`;

export const messageStyle = css`
    font-size: 16px;

    a {
        font-weight: ${FontWeight.MEDIUM};
        text-decoration: underline;
        color: ${Colors.Black.V100};
    }
`;
